import React from 'react'
import { useEffect } from 'react'
import Services from '../../Services';
import { Socket, SocketInstance } from '../../Services/socket/socket.client';
import { utility } from '../../helpers/loader';
import { Link, useHistory, useLocation } from "react-router-dom";
import { Spin, Image } from 'antd';
import axios from 'axios';
import Logo from '../../assets/img/Logo.png'

const EntraLogin = () => {
    const {
        users,
        Storage,
    } = Services;
    const location = useLocation()
    const storage = new Storage();
    const history = useHistory();
    const tokenLogin = async () => {
        if (location?.search) {
            const decodedToken = location?.search?.split('?session=')
            if (decodedToken?.length !== 0) {
                const response = await axios.post(`${process?.env?.REACT_APP_base}/api/auth/saml/session`, {}, { // Added empty object for body
                    headers: {
                        Authorization: `${decodedToken[1]}`
                    }
                });
                const {
                    data,
                    token,
                    role_id,
                    currentDateTime
                } = response?.data;
                storage.set('access_jwt', token);
                localStorage.removeItem('user_profile')
                storage.set('user_profile', JSON.stringify({ ...data, currentDateTime }));
                storage.set('role_id', role_id);
                SocketInstance.emit('employee-login', { currentDateTime, data, user_id: data?.id })
                history.push({
                    pathname: '/dashboard',
                    state: {
                        broaCast: true,
                        showBroadcastPopups: true
                    }
                })
                localStorage.setItem('isEmployee', JSON.stringify(true))
                localStorage.setItem('Source', JSON.stringify('Entra-ID'))
            }
        }
    }
    useEffect(() => {
        tokenLogin()
    }, [location])
    return (
        <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: 'column',
            height: "100vh",
            gap: "10px"
        }}>
            <div style={{
                display: "flex",
                boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                height: "250px",
                width: "300px",
                borderRadius: "10px",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: 'column',
                gap: "10px",
                background: "#215dab",
                color: "white"
            }}>
                <Image src={Logo} width={70} height={70} preview={false} style={{ objectFit: "contain" }} />
                <Spin style={{ color: "white" }} loading={true} size='large' />
                <h1 style={{
                    fontSize: '15px',
                    fontWeight: "600",
                    color: "white"
                }}
                >Verifying Please wait</h1>
            </div>
        </div>
    )
}

export default EntraLogin